
window.addEventListener('alpine:init', bootstrap);

export default (
) => ({
	positions: [],
	locations: [],
	departments: [],
	selected_location: '*',
	selected_department: '*',
	init() {
		this.setupPositions();
	},
	get filtered_positions() {
		return this.positions.filter(position => {
			if (this.selected_location !== '*' && position.location !== this.selected_location) {
				return false;
			}
			if (this.selected_department !== '*' && position.department !== this.selected_department) {
				return false;
			}
			return true;
		});
	},
	setupPositions() {
		const $groups = document.querySelectorAll('.comeet-outer-wrapper .comeet-g-r');
		$groups.forEach($group => {
			const location = $group.querySelector('.comeet-group-name').innerText;
			this.locations.push(location);
			const $positions = $group.querySelectorAll('.comeet-positions-list a');
			$positions.forEach($position => {
				const url = $position.href;
				const $name = $position.querySelector('.comeet-position-name');
				const name = Array.from($name.childNodes)
					.filter(node => node.nodeType === Node.TEXT_NODE)
					.map(node => node.textContent)
					.join('')
					.trim();
				const position_info = $position.querySelector('.comeet-position-meta').innerText;
				const [department, time, level] = position_info.split(' · ');
				if (!this.departments.includes(department)) {
					this.departments.push(department);
				}
				this.positions.push({
					name,
					location,
					department,
					time,
					level,
					url,
				});
			});
		});
	},
});

function bootstrap() {
	document.querySelectorAll('.comeet-outer-wrapper')
		.forEach($el => bootstrapComeetOuterWrapper($el))
	;
}

function bootstrapComeetOuterWrapper($el) {
	const $div = document.createElement('div');
	$div.setAttribute('x-data', 'comeetPluginFilter');
	$div.insertAdjacentHTML(
		'afterbegin',
		`<div class="filter-controls" style="display: flex; gap: 10px; margin-bottom: 10px;">
            <select x-model="selected_location">
                <option value="*">All Locations</option>
                <template x-for="location in locations">
                    <option x-text="location" :value="location"></option>
                </template>
            </select>

            <select x-model="selected_department">
                <option value="*">All Departments</option>
                <template x-for="department in departments">
                    <option x-text="department" :value="department"></option>
                </template>
            </select>
        </div>`
	);
	$div.insertAdjacentHTML(
		'beforeend',
		`<div>
            <template x-for="position in filtered_positions">
                <div style="border-bottom: 1px solid #ccc; padding: 10px; display: flex; gap: 10px;">
                    <div x-text="position.location"></div>
                    <div>
                        <a :href="position.url" x-text="position.name"></a>
                        <div style="display: flex; gap: 10px;">
                            <span x-text="position.department"></span> |
                            <span x-text="position.level"></span> |
                            <span x-text="position.time"></span>
                        </div>
                    </div>
                </div>
            </template>
        </div>`
	);
	$el.parentNode.insertBefore($div, $el);
	$el.style.display = 'none';
}
